import type { CalculatorCurrencySession } from './types'

export const createEmptyCalculatorSession = (): CalculatorCurrencySession => ({
  moneyIn: null,
  entries: [],
})

export const getCalculatorSessionEntryCount = (session: CalculatorCurrencySession) =>
  session.entries.length

export const calculatorSessionHasActivity = (session: CalculatorCurrencySession) =>
  (session.moneyIn ?? 0) > 0 || session.entries.length > 0
